var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"mode":"holdback","items":_vm.holdbacks},on:{"delete":_vm.onDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }